import { createAsyncThunk } from "@reduxjs/toolkit";

import { getCurrentSessionInformation, postVisitInfo } from "@/models";
import type { VisitParams } from "@/types";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchCurrentSessionInformation = createAsyncThunk(
  "visitsLogging/fetchCurrentSessionInformation",
  async (_, { rejectWithValue, getState }) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());
    const { baseUrl } = adapter.adapter;

    try {
      const sessionInfo = await getCurrentSessionInformation(token, baseUrl);
      return sessionInfo;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const saveVisitInfo = createAsyncThunk(
  "visitsLogging/saveVisitInfo",
  async (params: Partial<VisitParams>, { rejectWithValue, getState }) => {
    const { adapter, visitsLogging } = getState() as AppState;
    const { token } = fetchAuthToken(getState());
    const { baseUrl } = adapter.adapter;

    const visitInfo = {
      ...params,
      ...visitsLogging.sessionInfo
    };

    try {
      const response = await postVisitInfo(token, baseUrl, visitInfo);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
